import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FormSetting } from '../store/carriers-list/carriers-list.types';
import { generateHttpParams } from '../utils/general.utils';

@Injectable({ providedIn: 'root' })
export class DefaultFormSettingsService {
  private readonly http = inject(HttpClient);

  formKeys(entityUrl: string): Observable<string[]> {
    return this.http.get<string[]>(`${entityUrl}/GetDefaultFormSettingFormKeys`);
  }

  getFormSettings(entityUrl: string, formKey: string): Observable<FormSetting[]> {
    return this.http.get<FormSetting[]>(`${entityUrl}/GetDefaultFormSettings`, {
      params: generateHttpParams({ formKey }),
    });
  }

  getFields(entityUrl: string, formKey: string): Observable<string[]> {
    return this.http.get<string[]>(`${entityUrl}/GetDefaultFormSettingFields`, {
      params: generateHttpParams({ formKey }),
    });
  }

  update(entityUrl: string, formKey: string, payload: FormSetting[]): Observable<FormSetting[]> {
    return this.http.post<FormSetting[]>(`${entityUrl}/UpdateDefaultFormSettings`, payload, {
      params: generateHttpParams({ formKey }),
    });
  }
}
